import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeFilter", "zoneFilter", "scpiCard", "featuredSection", "allSection"]

  connect() {
    this.filter()
  }

  filter() {
    const selectedType = this.typeFilterTarget.value
    const selectedZone = this.zoneFilterTarget.value
    
    let visibleCount = 0
    let visibleFeaturedCount = 0

    this.scpiCardTargets.forEach(card => {
      const type = card.dataset.scpiType
      const zone = card.dataset.scpiZone
      const featured = card.dataset.scpiFeatured === "true"
      
      const typeMatch = !selectedType || type === selectedType
      const zoneMatch = !selectedZone || zone === selectedZone
      
      if (typeMatch && zoneMatch) {
        card.classList.remove("hidden")
        visibleCount++
        if (featured) visibleFeaturedCount++
      } else {
        card.classList.add("hidden")
      }
    })

    // Hide featured section if no featured items visible
    if (this.hasFeaturedSectionTarget) {
      if (visibleFeaturedCount === 0) {
        this.featuredSectionTarget.classList.add("hidden")
      } else {
        this.featuredSectionTarget.classList.remove("hidden")
      }
    }

    // Show "no results" message if needed
    if (visibleCount === 0) {
      if (!document.getElementById("no-results")) {
        const noResults = document.createElement("div")
        noResults.id = "no-results"
        noResults.className = "col-span-full text-center py-8"
        noResults.innerHTML = `
          <p class="text-gray-500 text-lg">Aucune SCPI ne correspond à vos critères.</p>
          <button onclick="location.reload()" class="mt-4 text-[#2E7D32] hover:underline">Réinitialiser les filtres</button>
        `
        this.allSectionTarget.querySelector(".grid").appendChild(noResults)
      }
    } else {
      const noResults = document.getElementById("no-results")
      if (noResults) noResults.remove()
    }
  }

  reset() {
    this.typeFilterTarget.value = ""
    this.zoneFilterTarget.value = ""
    this.filter()
  }
}